module.exports = __webpack_public_path__ + "img/gi_macet.fea3d674.png";